import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  IconButton,
  Box,
  Paper
} from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { toast } from 'react-toastify';

const BlacklistWarningModal = ({ isOpen, onClose, message }) => {
  const handleCopy = () => {
    if (message) {
      navigator.clipboard.writeText(message)
        .then(() => {
          toast.success('คัดลอกข้อความเรียบร้อยแล้ว');
        })
        .catch(err => {
          console.error('Failed to copy text: ', err);
          toast.error('ไม่สามารถคัดลอกข้อความได้');
        });
    }
  };

  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 2,
        }
      }}
    >
      <DialogTitle sx={{ 
        pb: 1,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
      }}>
        <Typography variant="h6" component="span">
          คำเตือน
        </Typography>
        <IconButton
          onClick={handleCopy}
          size="small"
          sx={{ ml: 1 }}
          title="คัดลอกข้อความ"
        >
          <ContentCopyIcon fontSize="small" />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Paper
          elevation={0}
          sx={{
            p: 2,
            backgroundColor: '#f5f5f5',
            borderRadius: 1,
            border: '1px solid #e0e0e0',
            whiteSpace: 'pre-wrap',
            userSelect: 'text',
            cursor: 'text'
          }}
        >
          <Typography
            variant="body1"
            sx={{
              fontFamily: 'inherit',
              lineHeight: 1.8,
              wordBreak: 'break-word'
            }}
          >
            {message}
          </Typography>
        </Paper>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button
          onClick={onClose}
          variant="contained"
          color="primary"
          autoFocus
        >
          ตกลง
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default BlacklistWarningModal;

